var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contact-me"},[_c('p',{staticClass:"baseline"},[_vm._v("Mon profil vous intéresse ?")]),_c('router-link',{attrs:{"to":"/contact"}},[_c('p',{staticClass:"contact-btn"},[_vm._v("Me contacter")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }